import { createTheme } from "@material-ui/core/styles"
/**
 * Customized MUI Theme
 * @type {Theme}
 */
const theme = createTheme({
  direction: "rtl",
  typography: {
    fontFamily: "Vazir, cursive",
  },
  palette: {
    primary: {
      light: "#FEF7F4",
      border: "#F9C1AB",
      main: "#F0632D",
    },
    secondary: {
      main: "#2CBBB5",
    },
    text: {
      secondary: "#6a6a6a",
      success: "#02b53e",
    },
    success: {
      main: "#02b53e",
    },
  },
  overrides: {
    MuiButton: {
      root: {
        borderRadius: "8px !important",
      },
    },
    MuiPaper: {
      rounded: {
        borderRadius: "8px !important",
      },
    },
  },
})

export default theme
